import * as React from 'react';
import { Box, Grid, styled, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';
import { Text } from 'library';
import { useHistory } from 'react-router';
import SignupForm from './SignUpForm';
import Image from 'assets/images/LoginSignUpImage.jpg';
import SignUpLoginTab from 'parent-portal/public/SignUpLoginTab';
import SignUpLoginHeader from 'parent-portal/public/SignUpLoginHeader';
import SignUpLoginContainer from 'parent-portal/public/SignUpLoginContainer';
import Colors from 'constants/Colors';
import DownloadRow from 'parent-portal/shared/Footer/DownloadRow';
import theme from 'theme';

export default function SignUpPage() {
    const history = useHistory();
    const [role, setRole] = React.useState<'program' | 'teacher'>('program');

    return (
        <SignUpLoginContainer>
            <FormContainer item sm={12} md={6}>
                <Grid container justifyContent="center">
                    <SignUpLoginTab />
                </Grid>

                <Content container>
                    <Grid container item xs={12}>
                        <SignUpLoginHeader>Create an Account</SignUpLoginHeader>
                    </Grid>
                    <Grid container item xs={12}>
                        <FormControl component="fieldset" sx={{ marginTop: 2 }}>
                            <FormLabel component="legend">
                                <Text variant="body1" bold>
                                    1. Please select which of the following best describes you.*
                                </Text>
                            </FormLabel>
                            <RadioGroup
                                row
                                value={role}
                                onChange={(e) => setRole(e.target.value as 'program' | 'teacher')}
                                sx={{ marginTop: 1 }}
                            >
                                <FormControlLabel
                                    sx={{
                                        color: Colors.darkNavy,
                                        fontFamily: 'Outfit',
                                    }}
                                    value="program"
                                    control={
                                        <Radio
                                            sx={{
                                                color: Colors.darkNavy,
                                                '&.Mui-checked': {
                                                    color: Colors.darkNavy,
                                                },
                                            }}
                                        />
                                    }
                                    label={<Text variant="body2">Childcare Program Looking for Staff</Text>}
                                />
                                <FormControlLabel
                                    sx={{
                                        color: Colors.darkNavy,
                                        fontFamily: 'Outfit',
                                    }}
                                    value="teacher"
                                    control={
                                        <Radio
                                            sx={{
                                                color: Colors.darkNavy,
                                                '&.Mui-checked': {
                                                    color: Colors.darkNavy,
                                                },
                                            }}
                                        />
                                    }
                                    label={<Text variant="body2">Teacher Looking for Work</Text>}
                                />
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    {role === 'program' && (
                        <>
                            <Text variant="body1" bold textStyle={{ marginTop: 10 }}>
                                2. Complete the information below to get started.
                            </Text>
                            <Text variant="caption">
                                You should only complete this step if you are a childcare program.
                            </Text>
                            <div>
                                <SignupForm
                                    onComplete={() => history.push('/home')}
                                    hideReferral={false}
                                    businessSignup={true}
                                    modal={false}
                                    skipToPhone={false}
                                    hideHeader={true}
                                    onNotBusinessClick={() => {
                                        setRole('teacher');
                                        window.scrollTo(0, 0);
                                    }}
                                />
                            </div>
                        </>
                    )}

                    {role === 'teacher' && (
                        <Grid style={{ marginTop: 10 }}>
                            <Text variant="body1" bold>
                                2. Download the Tandem app to create an account as a teacher.
                            </Text>
                            <DownloadRow />
                        </Grid>
                    )}
                </Content>
            </FormContainer>

            <Grid item sm={12} md={6}>
                <Box
                    component="img"
                    src={Image}
                    alt="Customer testimonial"
                    sx={{ width: '100%', height: '90vh' }}
                    display={{ xs: 'none', sm: 'none', md: 'block' }}
                />
            </Grid>
        </SignUpLoginContainer>
    );
}

const FormContainer = styled(Grid)({
    padding: 40,
});

const Content = styled(Grid)({
    padding: '12%',
    [theme.breakpoints.down('sm')]: {
        padding: '3%',
    },
    paddingTop: '5%',
});
